// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_hf","advertCardNum":"c-a_hg"};